/** Existing BG editorial score; not a country-eligibility or regulatory score. */
export const STAKE_EDITORIAL_RATING = 4.6;
export const STAKE_LOGO = "/logos/getstake.jpg";
